import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Keepalive } from '@ng-idle/keepalive';
import { AppDialogConfig } from 'src/app/core/config/dialog.config';
import { TimeoutModalComponent } from '../components/timeout-dialog/timeout-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root'
})
export class IdleService {
    private destroyRef = inject(DestroyRef);
    private static readonly IdleDurationLongInSeconds = 7200; // 2 hours
    private static readonly IdleDurationShortInSeconds = 540; // 9 minutes
    private static readonly TimeoutDurationInSeconds = 60;

    private dialogRef: MatDialogRef<TimeoutModalComponent>;
    private operation: Function = () => {};

    constructor(
        private idle: Idle,
        private keepalive: Keepalive,
        private dialogService: MatDialog
    ) {
        this.idle.setTimeout(IdleService.TimeoutDurationInSeconds);
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onIdleEnd.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.closeTimeoutDialog());
        this.idle.onTimeout.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.closeTimeoutDialog();
            this.startIdleCheckingShort();
            this.operation();
        });
        
        this.idle.onIdleStart.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            let config = AppDialogConfig.getStandardConfiguration();
            config.data.idle = this.idle;

            this.dialogRef = this.dialogService.open(TimeoutModalComponent, config);
        });
        
        // Every n seconds do this if the user is active
        this.keepalive.interval(15);
        this.keepalive.onPing.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => console.debug(new Date()));
    }

    public setTimeoutOperation(operation: Function) {
        this.operation = operation;
    }

    public startIdleCheckingShort() {
        this.idle.setIdle(IdleService.IdleDurationShortInSeconds);
        this.idle.watch();
    }

    public startIdleCheckingLong() {
        this.idle.setIdle(IdleService.IdleDurationLongInSeconds);
        this.idle.watch();
    }

    public stopIdleChecking() {
        this.idle.stop();
    }

    private closeTimeoutDialog() {
        if (this.dialogRef !== undefined) {
            this.dialogService.closeAll();
        }
    }
}
